export default __webpack_public_path__ + "dfc43728e407faf7a1356dd01d4d07e0.png";